import { httpClient } from '@/api/httpClient';
import { resolveAttachmentFilename, type DownloadedFile } from '@/api/fileDownload';
import {
  mapApiResourceToFirstConsultationShare,
  mapApiResourceToFirstConsultationVersions,
  type FirstConsultationShare,
  type FirstConsultationShareApiResource,
  type FirstConsultationVersion,
  type FirstConsultationVersionApiResource,
} from './firstConsultationSharingApi.types';

const DEFAULT_FIRST_CONSULTATION_FILENAME = 'first-consultation.pdf';

export async function shareFirstConsultation(
  consultationId: string
): Promise<FirstConsultationShare> {
  const response = await httpClient.post<FirstConsultationShareApiResource>(
    '/first-consultations/' + consultationId + '/share'
  );
  return mapApiResourceToFirstConsultationShare(response.data);
}

export async function unshareFirstConsultation(
  consultationId: string
): Promise<FirstConsultationShare> {
  const response = await httpClient.post<FirstConsultationShareApiResource>(
    '/first-consultations/' + consultationId + '/unshare'
  );
  return mapApiResourceToFirstConsultationShare(response.data);
}

export async function fetchFirstConsultationVersions(
  consultationId: string
): Promise<FirstConsultationVersion[]> {
  const response = await httpClient.get<FirstConsultationVersionApiResource[]>(
    '/first-consultations/' + consultationId + '/versions'
  );
  return mapApiResourceToFirstConsultationVersions(response.data);
}

export async function downloadFirstConsultationPdf(
  consultationId: string
): Promise<DownloadedFile> {
  const response = await httpClient.get<Blob>('/first-consultations/' + consultationId + '/pdf', {
    responseType: 'blob',
  });
  return {
    blob: response.data,
    filename: resolveAttachmentFilename(
      response.headers['content-disposition'],
      DEFAULT_FIRST_CONSULTATION_FILENAME
    ),
  };
}
